import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import clsx from 'clsx';
import { useCallback } from 'react';
import Link from 'next/link';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GridIcon = function GridIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#515466",
      fillRule: "evenodd",
      d: "M5.333 0a.889.889 0 0 0-.889.889v3.555H.89a.889.889 0 0 0 0 1.778h3.555v3.556H.89a.889.889 0 1 0 0 1.778h3.555v3.555a.889.889 0 0 0 1.778 0v-3.555h3.556v3.555a.889.889 0 1 0 1.778 0v-3.555h3.555a.889.889 0 0 0 0-1.778h-3.555V6.222h3.555a.889.889 0 0 0 0-1.778h-3.555V.89a.889.889 0 0 0-1.778 0v3.555H6.222V.89A.889.889 0 0 0 5.333 0Zm4.445 9.778V6.222H6.222v3.556h3.556Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#515466",
      fillRule: "evenodd",
      d: "M0 4.444A4.444 4.444 0 0 1 4.444 0h7.112A4.444 4.444 0 0 1 16 4.444v7.112A4.444 4.444 0 0 1 11.556 16H4.444A4.444 4.444 0 0 1 0 11.556V4.444Zm4.444-2.666a2.667 2.667 0 0 0-2.666 2.666v7.112a2.667 2.667 0 0 0 2.666 2.666h7.112a2.667 2.667 0 0 0 2.666-2.666V4.444a2.667 2.667 0 0 0-2.666-2.666H4.444Z",
      clipRule: "evenodd"
    })]
  }));
};

GridIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};

var SelectIcon = function SelectIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_4990_594)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M14.802 2.22266C15.1005 2.22266 15.3868 2.33973 15.5979 2.54813C15.8089 2.75653 15.9275 3.03918 15.9275 3.33391C15.9275 3.62863 15.8089 3.91128 15.5979 4.11968C15.3868 4.32808 15.1005 4.44516 14.802 4.44516H5.79843C5.49994 4.44516 5.21368 4.32808 5.00261 4.11968C4.79155 3.91128 4.67298 3.62863 4.67298 3.33391C4.67298 3.03918 4.79155 2.75653 5.00261 2.54813C5.21368 2.33973 5.49994 2.22266 5.79843 2.22266H14.802ZM3.54752 4.44516C3.24948 4.44549 2.96373 4.56254 2.75298 4.77063C2.54222 4.97873 2.42367 5.26087 2.42334 5.55516V14.4452C2.42334 14.7399 2.54191 15.0225 2.75298 15.2309C2.96404 15.4393 3.2503 15.5564 3.54879 15.5564C3.84728 15.5564 4.13354 15.4393 4.34461 15.2309C4.55567 15.0225 4.67424 14.7399 4.67424 14.4452V5.55516C4.67408 5.40922 4.6448 5.26475 4.58809 5.12999C4.53138 4.99523 4.44834 4.87282 4.34371 4.76975C4.23908 4.66668 4.11492 4.58496 3.97831 4.52927C3.8417 4.47357 3.69532 4.44499 3.54752 4.44516ZM17.0517 4.44516C16.7534 4.44516 16.4673 4.56206 16.2563 4.77019C16.0453 4.97832 15.9266 5.26065 15.9262 5.55516V14.4452C15.9262 14.7399 16.0448 15.0225 16.2559 15.2309C16.4669 15.4393 16.7532 15.5564 17.0517 15.5564C17.3502 15.5564 17.6364 15.4393 17.8475 15.2309C18.0586 15.0225 18.1771 14.7399 18.1771 14.4452V5.55516C18.1768 5.26065 18.0581 4.97832 17.847 4.77019C17.636 4.56206 17.3499 4.44516 17.0517 4.44516ZM15.9262 16.6664C15.9262 16.3719 15.8078 16.0894 15.597 15.8811C15.3862 15.6727 15.1003 15.5555 14.802 15.5552H5.79843C5.49994 15.5552 5.21368 15.6722 5.00261 15.8806C4.79155 16.089 4.67298 16.3717 4.67298 16.6664C4.67298 16.9611 4.79155 17.2438 5.00261 17.4522C5.21368 17.6606 5.49994 17.7777 5.79843 17.7777H14.802C15.4224 17.7777 15.9262 17.2802 15.9262 16.6664Z",
        fill: "#515466"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M3.54879 4.44488C3.2503 4.44488 2.96403 4.3278 2.75297 4.1194C2.54191 3.91101 2.42333 3.62835 2.42333 3.33363C2.42333 3.03891 2.54191 2.75626 2.75297 2.54786C2.96403 2.33946 3.2503 2.22238 3.54879 2.22238C3.84727 2.22238 4.13354 2.33946 4.3446 2.54786C4.55566 2.75626 4.67424 3.03891 4.67424 3.33363C4.67424 3.62835 4.55566 3.91101 4.3446 4.1194C4.13354 4.3278 3.84727 4.44488 3.54879 4.44488ZM0.172431 3.33238C0.16374 2.88924 0.244631 2.44883 0.410373 2.03692C0.576115 1.62502 0.823381 1.24988 1.13771 0.933448C1.45203 0.61702 1.82711 0.365657 2.24099 0.194061C2.65488 0.0224648 3.09926 -0.065918 3.54815 -0.065918C3.99704 -0.065918 4.44143 0.0224648 4.85531 0.194061C5.2692 0.365657 5.64427 0.61702 5.9586 0.933448C6.27292 1.24988 6.52019 1.62502 6.68593 2.03692C6.85167 2.44883 6.93257 2.88924 6.92387 3.33238C6.90675 4.2052 6.54358 5.03657 5.91237 5.64786C5.28116 6.25915 4.4323 6.60158 3.54815 6.60158C2.66401 6.60158 1.81514 6.25915 1.18394 5.64786C0.55273 5.03657 0.189551 4.2052 0.172431 3.33238ZM17.0517 4.44488C16.7532 4.44488 16.4669 4.3278 16.2559 4.1194C16.0448 3.91101 15.9262 3.62835 15.9262 3.33363C15.9262 3.03891 16.0448 2.75626 16.2559 2.54786C16.4669 2.33946 16.7532 2.22238 17.0517 2.22238C17.3502 2.22238 17.6364 2.33946 17.8475 2.54786C18.0585 2.75626 18.1771 3.03891 18.1771 3.33363C18.1771 3.62835 18.0585 3.91101 17.8475 4.1194C17.6364 4.3278 17.3502 4.44488 17.0517 4.44488ZM13.6766 3.33238C13.6679 2.88924 13.7488 2.44883 13.9145 2.03692C14.0803 1.62502 14.3275 1.24988 14.6419 0.933448C14.9562 0.61702 15.3313 0.365657 15.7451 0.194061C16.159 0.0224648 16.6034 -0.065918 17.0523 -0.065918C17.5012 -0.065918 17.9456 0.0224648 18.3595 0.194061C18.7733 0.365657 19.1484 0.61702 19.4627 0.933448C19.7771 1.24988 20.0243 1.62502 20.1901 2.03692C20.3558 2.44883 20.4367 2.88924 20.428 3.33238C20.4109 4.2052 20.0477 5.03657 19.4165 5.64786C18.7853 6.25915 17.9364 6.60158 17.0523 6.60158C16.1682 6.60158 15.3193 6.25915 14.6881 5.64786C14.0569 5.03657 13.6937 4.2052 13.6766 3.33238ZM2.42207 16.6661C2.42207 16.9609 2.54064 17.2435 2.75171 17.4519C2.96277 17.6603 3.24903 17.7774 3.54752 17.7774C3.84601 17.7774 4.13227 17.6603 4.34333 17.4519C4.5544 17.2435 4.67297 16.9609 4.67297 16.6661C4.66318 16.378 4.54038 16.1049 4.33051 15.9046C4.12063 15.7042 3.84011 15.5921 3.54815 15.5921C3.2562 15.5921 2.97567 15.7042 2.7658 15.9046C2.55592 16.1049 2.43312 16.378 2.42333 16.6661H2.42207ZM3.54879 13.3336C3.09998 13.325 2.65394 13.4049 2.23677 13.5686C1.8196 13.7322 1.43967 13.9764 1.11919 14.2867C0.798722 14.5971 0.544146 14.9674 0.370357 15.3761C0.196568 15.7848 0.107056 16.2235 0.107056 16.6668C0.107056 17.11 0.196568 17.5488 0.370357 17.9574C0.544146 18.3661 0.798722 18.7364 1.11919 19.0468C1.43967 19.3571 1.8196 19.6013 2.23677 19.7649C2.65394 19.9286 3.09998 20.0085 3.54879 19.9999C4.43276 19.983 5.27476 19.6244 5.89386 19.0011C6.51296 18.3779 6.85976 17.5397 6.85976 16.6668C6.85976 15.7938 6.51296 14.9556 5.89386 14.3324C5.27476 13.7091 4.43276 13.3505 3.54879 13.3336ZM17.0517 17.7774C16.7532 17.7774 16.4669 17.6603 16.2559 17.4519C16.0448 17.2435 15.9262 16.9609 15.9262 16.6661C15.9262 16.3714 16.0448 16.0888 16.2559 15.8804C16.4669 15.672 16.7532 15.5549 17.0517 15.5549C17.3502 15.5549 17.6364 15.672 17.8475 15.8804C18.0585 16.0888 18.1771 16.3714 18.1771 16.6661C18.1771 16.9609 18.0585 17.2435 17.8475 17.4519C17.6364 17.6603 17.3502 17.7774 17.0517 17.7774ZM13.6766 16.6661C13.6679 16.223 13.7488 15.7826 13.9145 15.3707C14.0803 14.9588 14.3275 14.5836 14.6419 14.2672C14.9562 13.9508 15.3313 13.6994 15.7451 13.5278C16.159 13.3562 16.6034 13.2678 17.0523 13.2678C17.5012 13.2678 17.9456 13.3562 18.3595 13.5278C18.7733 13.6994 19.1484 13.9508 19.4627 14.2672C19.7771 14.5836 20.0243 14.9588 20.1901 15.3707C20.3558 15.7826 20.4367 16.223 20.428 16.6661C20.4109 17.539 20.0477 18.3703 19.4165 18.9816C18.7853 19.5929 17.9364 19.9353 17.0523 19.9353C16.1682 19.9353 15.3193 19.5929 14.6881 18.9816C14.0569 18.3703 13.6937 17.539 13.6766 16.6661Z",
        fill: "#515466"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_4990_594",
        children: /*#__PURE__*/_jsx("rect", {
          width: "20.2556",
          height: "20",
          fill: "white",
          transform: "translate(0.172424)"
        })
      })
    })]
  }));
};

SelectIcon.defaultProps = {
  width: "21",
  height: "20",
  viewBox: "0 0 21 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CircleSquareIcon = function CircleSquareIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      fill: "#12131A",
      clipPath: "url(#a)",
      children: [/*#__PURE__*/_jsx("path", {
        fillOpacity: ".25",
        d: "M5.333 7.111c0-.982.796-1.778 1.778-1.778h7.111c.982 0 1.778.796 1.778 1.778v7.111c0 .982-.796 1.778-1.778 1.778h-7.11a1.778 1.778 0 0 1-1.779-1.778v-7.11Z"
      }), /*#__PURE__*/_jsx("path", {
        d: "M10.667 5.333A5.333 5.333 0 1 1 0 5.333a5.333 5.333 0 0 1 10.667 0Z"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "a",
        children: /*#__PURE__*/_jsx("path", {
          fill: "#fff",
          d: "M0 0h16v16H0z"
        })
      })
    })]
  }));
};

CircleSquareIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};

var ExportIcon = function ExportIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#515466",
      fillRule: "evenodd",
      d: "M0 10.881v-2.88a.889.889 0 1 1 1.778 0v2.844c0 .76 0 1.278.033 1.679.032.39.09.589.16.728.171.334.443.606.777.776.14.071.339.13.728.16.4.034.918.034 1.68.034h5.688c.762 0 1.28 0 1.68-.033.39-.032.589-.09.728-.16.334-.17.606-.443.776-.777.071-.14.129-.339.16-.728.034-.4.034-.918.034-1.68V8A.889.889 0 1 1 16 8v2.881c0 .716 0 1.306-.04 1.787-.04.5-.128.96-.348 1.39a3.556 3.556 0 0 1-1.553 1.555c-.432.22-.891.307-1.39.348-.482.04-1.072.04-1.788.04H5.12c-.716 0-1.306 0-1.787-.04-.5-.041-.96-.129-1.39-.348a3.556 3.556 0 0 1-1.554-1.554c-.22-.432-.308-.891-.349-1.39C0 12.186 0 11.596 0 10.88Z",
      clipRule: "evenodd"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#515466",
      d: "M5.962 4.184a.889.889 0 1 1-1.257-1.257L7.37.26a.889.889 0 0 1 1.257 0l2.667 2.667a.889.889 0 0 1-1.257 1.257l-1.15-1.15v7.633a.889.889 0 0 1-1.777 0V3.035l-1.15 1.15Z"
    })]
  }));
};

ExportIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
};

var ArrowRightIcon = function ArrowRightIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.29286 6.29289C7.90234 6.68342 7.90234 7.31658 8.29286 7.70711L12.5858 12L8.29286 16.2929C7.90234 16.6834 7.90234 17.3166 8.29286 17.7071C8.68339 18.0976 9.31655 18.0976 9.70708 17.7071L15.4142 12L9.70708 6.29289C9.31655 5.90237 8.68339 5.90237 8.29286 6.29289Z",
      fill: "#12131A"
    })
  }));
};

ArrowRightIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const ButtonListNav = _ref => {
  let {
    links = [],
    active = '',
    notice = '',
    className,
    onOpen
  } = _ref;
  const handleLinkClick = useCallback((evt, href) => {
    if (onOpen) {
      onOpen(href);
      evt.preventDefault();
    }
  }, [onOpen]);
  return /*#__PURE__*/_jsx("ul", {
    className: clsx(styles.container, className || ''),
    "data-active": active,
    children: links.map((link, index) => /*#__PURE__*/_jsx(LinkSegement, {
      link: link,
      index: index,
      linkCount: links.length,
      active: active,
      notice: notice,
      handleLinkClick: handleLinkClick
    }, link.href))
  });
};

export default ButtonListNav;

const Icon = _ref2 => {
  let {
    pathRef,
    className = ''
  } = _ref2;
  const baseClaseName = styles[`linkIcon--${pathRef}`];

  if (pathRef === 'grid') {
    return /*#__PURE__*/_jsx(GridIcon, {
      className: clsx(baseClaseName, className)
    });
  } else if (pathRef === 'select') {
    return /*#__PURE__*/_jsx(SelectIcon, {
      className: clsx(baseClaseName, className)
    });
  } else if (pathRef === 'circle-square') {
    return /*#__PURE__*/_jsx(CircleSquareIcon, {
      className: clsx(baseClaseName, className)
    });
  } else if (pathRef === 'export') {
    return /*#__PURE__*/_jsx(ExportIcon, {
      className: clsx(baseClaseName, className)
    });
  }

  return /*#__PURE__*/_jsx(_Fragment, {});
};

const LinkSegement = _ref3 => {
  let {
    link,
    index,
    linkCount,
    active,
    notice,
    handleLinkClick
  } = _ref3;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("li", {
      children: /*#__PURE__*/_jsx(Link, {
        href: link.href,
        className: styles.link,
        onClick: evt => handleLinkClick(evt, link.href),
        children: link.tooltip ? /*#__PURE__*/_jsx(Tooltip, {
          placement: "bottom",
          content: link.tooltip,
          tooltipClassName: styles.tooltip,
          allowEventPropagation: true,
          children: /*#__PURE__*/_jsx(LinkButton, {
            link: link,
            active: active,
            notice: notice
          })
        }) : /*#__PURE__*/_jsx(LinkButton, {
          link: link,
          active: active,
          notice: notice
        })
      })
    }, link.href), index < linkCount - 1 ? /*#__PURE__*/_jsx("li", {
      className: styles.chevron,
      children: /*#__PURE__*/_jsx(ArrowRightIcon, {})
    }, `${link.href}-chevron`) : null]
  });
};

const LinkButton = _ref4 => {
  let {
    link,
    active,
    notice
  } = _ref4;
  return /*#__PURE__*/_jsx(Button, {
    variant: ['pill', link.href === active ? 'pillActive' : ''],
    hasNotice: link.href === notice,
    leftIcon: /*#__PURE__*/_jsx(Icon, {
      pathRef: link.icon,
      className: link.href === active ? '-active' : ''
    }),
    children: link.text
  });
};